import { useBooleanState } from "~/common/hooks/useBooleanState";
import { QuickEntryPopup } from "~/features/quickEntry/v2/QuickEntryPopup";
import { hasProductConfiguredPC } from "~/features/quickEntry/utils/helpers";
import { useDispatch } from "react-redux";
import { quickEntryToCurrentWishlistThunk } from "~/features/wishlist/redux/wishlistSlice";
import { useTranslation } from "react-i18next";

export const useWishlistQuickEntry = () => {
  const { val: isModalOpen, setTrue, setFalse } = useBooleanState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const modal = isModalOpen && (
    <QuickEntryPopup
      onClose={setFalse}
      onAdd={async (form, setIsSending, onClose) => {
        const items = form.items.filter(hasProductConfiguredPC);
        setIsSending(true);
        await dispatch(
          quickEntryToCurrentWishlistThunk(items.map((item) => ({ code: item.product.code, quantity: item.quantity }))),
        );
        setIsSending(false);
        onClose();
      }}
      variant={"wishlist"}
      addButtonLabel={t("page.search.tabular.action.addToWishlist")}
    />
  );

  return [modal, setTrue] as const;
};
